<sdps-divider variation="secondary"></sdps-divider>
<span id="section-title">Transaction details</span>
<ng-container *ngIf="hasBadRequestServiceError">
  <mm-banners *ngFor="let error of serviceErrorList" [parentForm]="transactionDetailsGroup" [bannerText]="[error]"
    [type]="'error'" id="transactionDetailsWireInterimIso_badRequestServiceError"
    data-testid="transactionDetailsWireInterimIso_badRequestServiceError"></mm-banners>
</ng-container>
<mm-banners *ngIf="hasServiceError" [serviceError]="(transactionFormServiceError$ | async)!" [type]="'error'"
  id="transactionDetailsWireInterimIso_serviceError"
  data-testid="transactionDetailsWireInterimIso_serviceError"></mm-banners>
<mm-banners *ngIf="(wireAbaCode$ | async) === abaCodes.ABA_WITH_WARNING_TWO_INSTITUTIONS"
  [bannerText]="[intermediaryRequiredText]" [type]="'information'"></mm-banners>
<form [formGroup]="transactionDetailsGroup" id="transaction-details-wire-interim-iso">
  <mm-wire-intermediary-iso [parentForm]="transactionDetailsGroup" [useSloa]="(useSloa$ | async)!"
    [isFromCreateTransaction]=true [useTemplate]="(useTemplate$ | async)!" [wireInfo$]="wireInfo$"
    [wireIntermediary$]="wireIntermediary$"
    [missingIntermediaryAddress]="(missingIntermediaryAddress$ | async)!"
    [canDisplayCreditToInfo]="(canDisplayCreditToInfo$ | async)!"
    [palAccountInContext]="palAccountInContext"
    [countryList$]="countryList$"
    [fromTemplateStartTransaction]="fromTemplateStartTransaction"
    [isFromEditReview]="(isFromEditReview | async) ?? false">
  </mm-wire-intermediary-iso>
  <span id="header" *ngIf="!(showIntermediaryFields$ | async)" class="display-flex" [ngClass]="(useSloa$ | async)! ? 'not-active' : 'active'">Recipient bank</span>
  <mm-wire-aba [hidden]="(showIntermediaryFields$ | async)" [parentForm]="transactionDetailsGroup" [useSloa]="(useSloa$ | async)!"
    [isFromIntermediaryInterim]=false [isFromCreateTransaction]=true [useTemplate]="(useTemplate$ | async)!" [palAccountInContext]="palAccountInContext" class="big-bottom-spacer" [wireInfo$]="wireInfo$"
    [wireAbaCode$]="wireAbaCode$" [wireDetailsError$]="wireDetailsError$"
    [wireDetailsWarning$]="wireDetailsWarning$">
  </mm-wire-aba>
  <mm-wire-recipient-interim [parentForm]="transactionDetailsGroup" [useSloa]="(useSloa$ | async)!"
    class="big-bottom-spacer" (recipientSelectionComplete)="isRecipientValid($event)">
  </mm-wire-recipient-interim>
  <div class="container" *ngIf="validRecipient">
    <mm-wire-iso-receiving-account-holder [parentForm]="transactionDetailsGroup"
      [isFromCreateTransaction]=true [receivingAccountHolder]="(receivingAccountHolderIso$ | async)!"
      [firstParty$]="firstParty$" [countryList$]="countryList$" [useSloa]="(useSloa$ | async)!"
      [missingThirdPartyAddress]="(missingThirdPartyAddress$ | async)!" [firstPartyPayees]="(firstPartyPayees$ | async)!"
      [payeeName$]="payeeName$!" [modifiedPayeeCheckbox$]="modifiedPayeeCheckBox$!"
      [isoModifiedPayeeName$]="isoModifiedPayeeName$!" [fromTemplateStartTransaction]="fromTemplateStartTransaction"
      [isFromEditReview]="(isFromEditReview | async) ?? false">
    </mm-wire-iso-receiving-account-holder>
    <hr class="bottom-divider">
    <div id="transactionDetailsWireInterimIsoIrsTaxPaymentSection" >
      <mm-wire-irs-tax-details [parentForm]="transactionDetailsGroup" *ngIf="isIrsAba" 
        [isFromCreateTransaction]=true [taxRemittance$]="taxRemittance$" [useSloa]="(useSloa$ | async)!"
        id="tax_Remittance" >
      </mm-wire-irs-tax-details>
    </div>
    <div class="row" id="transactionDetailsWireInterimIsoAmountSection">
      <div class="date-picker-control sdps-form-date_control">
        <mm-date-picker-control (showSufficientFundsWarningEvent)="setShowSufficientFundsWarning($event)"
          [parentForm]="transactionDetailsGroup" [label]="datePickerLabelName" [tooltip]="datePickertooltip"
          [showIntlWireTooltip]="isCountryDomestic" [minDate]="minDate" [maxDate]="maxDate"
          [disableWeekends]="true" [formControlValue]="defaultProcessDate"
          [formControlValidators]="datePickerValidators" [id]="'wire-process-date-picker'" [transactionType]="'wire'"
          id="transactionDetailsWireInterimIso_selectedDate">
        </mm-date-picker-control>
      </div>
      <div class="amount-label">
        <mm-amount-field (showWiresHighDollarAmountWarning)="setShowHighDollarAmountWarning($event)"
          [parentForm]="transactionDetailsGroup" [maxTransferAmount]="wireMaxTransferAmount"
          id="transactionDetailsWireInterimIso_transferAmount">
        </mm-amount-field>
      </div>
      <div *ngIf="isIra$ | async" class="amount-label">
        <mm-amount-type-selector id="transactionDetailsWireInterimIso_amountTypeSelector"
          [parentForm]="transactionDetailsGroup" [distributionReason$]="distributionReason$">
        </mm-amount-type-selector>
      </div>
      <div *ngIf="isPtrs" class="income-principal-label">
        <mm-trust-income-principal [parentForm]="transactionDetailsGroup" [availableCash]="availableCash"
          [datePickerControlName]="controlNames.selectedDate" [overdraftRulesFutureDate]="overdraftRulesFutureDate"
          [incomePercent$]="trustIncomePercent$" [principalPercent$]="trustPrincipalPercent$" [ptrsInfo$]="ptrsInfo$"
          [component]="'source'" [isFromAccount]="true">
        </mm-trust-income-principal>
      </div>
    </div>
    <div *ngIf="showSufficientFundsWarning" class="sufficient-funds-warning-msg-interimIsoWires">
      {{futureDatedSufficientFundsWarning}}
    </div>
    <div *ngIf="showHighDollarAmountWarning" class="wire-high-dollar-amount">
      <mm-banners [bannerText]="[wireHighDollarAmountText]" [type]="'warning'" id="interimWireHighDollarAmountWarning"
        data-testid="wireHighDollarAmountWarning">
      </mm-banners>
    </div>
    <div *ngIf="isPtrs" class="row-trust-fields">
      <div>
        <mm-trust-tax-category class="trust-tax-label" id="trust-tax-category" [parentForm]="transactionDetailsGroup"
          [taxCategories]="taxCategories$">
        </mm-trust-tax-category>
      </div>
      <div>
        <mm-trust-tax-code class="trust-tax-label" id="trust-tax-code" [parentForm]="transactionDetailsGroup"
          [codes]="taxCodes$">
        </mm-trust-tax-code>
      </div>
      <div class="amount-label-interimIsoWires">
        <mm-trust-paid-for *ngIf="!showPaidFor" id="trust-paid-for" [parentForm]="transactionDetailsGroup">
        </mm-trust-paid-for>
      </div>
      <div>
        <mm-trust-comment id="trust-comment" [parentForm]="transactionDetailsGroup"
          class="big-bottom-spacer"></mm-trust-comment>
      </div>
    </div>
    <div *ngIf="isPtrs && noPaidFor" class="paid-for-banner sdps-messaging warning-container"
      id="trust-paid-for-warning">
      <span class="sdps-messaging__icon warning sch-exclamation-triangle-2x"></span>
      <div class="sdps-messaging__text">
        <span class="sdps-messaging__title">"Paid For" choices are currently unavailable. This transaction will be
          created with "Paid For" of the trust itself.<br></span>
        <span class="sdps-messaging__Description">"Paid For" information can be updated via the
          <a (click)="getDrupalPdf('PTRS-adjustment-form')" target="_blank">PTRS Adjustment
            Form</a>.
        </span>
      </div>
    </div>
    <hr *ngIf="isIra$ | async">
    <mm-create-request-tax-withholdings id="transactionDetailsWireInterimIso_taxWithholdings" *ngIf="isIra$ | async"
      [parentForm]="transactionDetailsGroup" [taxWithholdings]="taxWithHolding"
      [distributionReasonTooltip]="wireDistributionReasonTooltip"
      [taxWithholdingsFormGroupDetails]="taxWithholdingsFormGroupDetails"
      [distributionReasonMap$]="distributionReasonMap$" [distributionReason$]="distributionReason$">
    </mm-create-request-tax-withholdings>
    <hr class="bottom-divider">
    <mm-wire-transmission-notes [parentForm]="transactionDetailsGroup" [useSloa]="(useSloa$ | async)!"
      [isFromCreateTransaction]=true [canDisplayCreditToInfo]="(canDisplayCreditToInfo$ | async)!"
      id="transactionDetailsWireInterimIso_transmissionNotes" class="big-bottom-spacer">
    </mm-wire-transmission-notes>
    <ng-container *ngIf="palAccountInContext && (palAgreementItems$ | async) as palItems">
      <hr class="bottom-divider">
      <div id="line-of-credit-acknowledgement" data-testid="line-of-credit-acknowledgement" class="big-bottom-spacer">
        <h2 id="subtitle">Line of credit acknowledgement</h2>
        <div class="pal-acknowledgement-box">
          <input type="checkbox" id="pal-acknowledgement-checkbox" data-testid="pal-acknowledgement-checkbox"
            formControlName="palAttestation">
          <label for="pal-acknowledgement-checkbox" class="pal-agreement-checkbox-label">
            <span>{{ palAgreementAcknowledgement$ | async }}</span><br>
            <ul class="pal-acknowledgement-list">
              <li *ngFor="let item of palItems">{{ item }}</li>
            </ul>
          </label>
        </div>
        <div *ngIf="transactionDetailsGroup.get('palAttestation')?.invalid && transactionDetailsGroup.get('palAttestation')?.touched"
          class="pal-attestation-error" data-testid="pal-attestation-error">
          {{ palAttestationError }}
        </div>
      </div>
    </ng-container>
  </div>
</form>
